import {
  track,
  parsePageType,
  getCustomerData
} from './shared';

const customerData = getCustomerData();

const customerProperties = customerData && {
  first_name: customerData.firstName,
  last_name: customerData.lastName,
  user_id: customerData.id,
  email: customerData.email,
  logged_in: customerData.logged_in
};

const pageLoaded = ({ classList }) => {
  track({
    eventName: 's_track',
    data: {
      s_event: 'Page Loaded',
      s_properties: {
        page_type: parsePageType(classList),
        ...customerProperties
      }
    }
  });
};

export default pageLoaded;
